module.exports = __webpack_public_path__ + "img/nft-inside-banner.25fc68cf.png";